export const CHANGE_MATCH_ANALYSIS_FILTER = "CHANGE_MATCH_ANALYSIS_FILTER";
export const RESET_MATCH_ANALYSIS_FILTER = "RESET_MATCH_ANALYSIS_FILTER";

const initialState = {
  matchAnalysisName:"",
  fromJp:false,
  job_position_id: null,
  selectedJobPositions: [],
  selectedJobPositionNames: null,
  notes_query: "",
  state:"",
  applicant_name:"",
  application_id:null,
  applicant_names:null,
  selectedJobApplications:[]
};

export default function matchAnalysisFilterReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_MATCH_ANALYSIS_FILTER:
      return {
        ...state,
        ...action.payload,
      };

    case RESET_MATCH_ANALYSIS_FILTER:
      return initialState;

    default:
      return state;
  }
}
